import { Component, OnInit, Pipe } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as ApexCharts from 'apexcharts';
@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.css'],
})
export class DashboardPageComponent implements OnInit {
  // Define the API endpoint for fetching dashboard data
  // and the API endpoint for score generation.
  panelOpenState = false;
  private getApi = environment.url + environment.dashboardGet;
  constructor(private makeapi: ApiService) {}
  NotImplementColor = '#56c2e6';
  // This function is called when the component is initialized
  ngOnInit(): void {
    // this.getdata.amizhthLoader('show')
    this.getValue();
  }
  // This function fetches the dashboard data from the API
  // and updates the dashboardData property.
  dashboardData: any = {};
  getValue() {
    this.makeapi
      .method(this.getApi + 'id=' + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.dashboardData = data;
        if (data.enableScoring == 2) {
          let str = data.tnimmTotalScore.toString();
          let val = str.split('.');
          this.grap(val[0], str);
        }
      });
  }
  // This function is called when the user clicks the "Generate Score" button.
  // It triggers the score generation process by calling the API.
  grap(val, str) {
    //
    let num: number = +val;
    let options = {
      series: [num],
      chart: {
        height: 350,
        type: 'radialBar',
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            show: true,
            name: {
              offsetY: -10,
              show: false,
              color: '#888',
              fontSize: '17px',
            },
            value: {
              formatter: function (val) {
                return str;
              },
              color: '#111',
              fontSize: '36px',
              show: true,
            },
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#ABE5A1'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: 'round',
      },
      labels: [],
    };
    let chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();
    //
  }
}
